/* CUSTOM KIYO START — kiyo-zahlungsinfo.js
   Puts the "Weitere Zahlungsoptionen" trigger into the Klarna box and drives the
   payment info drawer (open/close, backdrop, Esc, scroll lock, focus return).
   The drawer node is moved to <body> so position:fixed cannot be trapped by a
   transformed/filtered ancestor. While it is open every other <body> child is
   inert (aria-modal alone does not keep keyboard focus inside). Re-initialises on
   shopify:section:load and opens when the section is selected in the Theme Editor. */
(function () {
  var current = null; // root of the drawer that is open (for the single Escape handler)

  // Modal semantics: only attributes set here are removed again, so inert states of
  // other layers (e.g. the reviews drawer) stay intact. Skipped in the Theme Editor,
  // where the preview must stay clickable while the section is selected.
  function setInert(keep) {
    var changed = [];
    if (window.Shopify && window.Shopify.designMode) return changed;
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === keep || el.hasAttribute('inert')) return;
      if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(el.tagName)) return;
      el.setAttribute('inert', '');
      changed.push(el);
    });
    return changed;
  }
  function init() {
    document.querySelectorAll('[data-kpay]').forEach(function (root) {
      if (root.dataset.kpayReady) return;
      // A/B test: a hidden variant section must not add its trigger to the visible control product section
      var section = root.closest('.shopify-section');
      if (section && !section.getClientRects().length) return;
      var template = root.querySelector('[data-kpay-trigger]');
      var drawer = root.querySelector('[data-kpay-drawer]');
      if (!template || !drawer) return;
      root.dataset.kpayReady = '1';

      // Theme Editor reloads: drop a stale drawer of this section in <body> and stale triggers
      document.querySelectorAll('body > [data-kpay-drawer]').forEach(function (d) { if (d.id === drawer.id) d.remove(); });
      document.querySelectorAll('.kpay__trigger').forEach(function (b) { b.remove(); });

      document.body.appendChild(drawer);
      var panel = drawer.querySelector('.kpay-drawer__panel');
      var lastFocus = null;
      var inertList = [];

      // Any pointer down outside the panel closes the drawer (belt and braces on
      // top of the backdrop's own click handler, e.g. when a cookie banner or the
      // Shopify preview bar sits above the backdrop).
      function onOutside(e) {
        if (drawer.hidden || panel.contains(e.target)) return;
        close();
      }
      function open() {
        if (!drawer.hidden) return;
        lastFocus = document.activeElement;
        current = root;
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('kpay-drawer--open'); });
        // scroll-lock is the theme's own mechanism (html[scroll-lock] .page-wrapper{overflow:hidden}),
        // which also holds on iOS Safari where overflow on <html> alone does not
        document.documentElement.setAttribute('scroll-lock', '');
        document.documentElement.style.overflow = 'hidden';
        inertList = setInert(drawer);
        panel.focus();
        setTimeout(function () { document.addEventListener('pointerdown', onOutside, true); }, 0);
      }
      function close() {
        if (drawer.hidden) return;
        if (current === root) current = null;
        document.removeEventListener('pointerdown', onOutside, true);
        drawer.classList.remove('kpay-drawer--open');
        document.documentElement.removeAttribute('scroll-lock');
        document.documentElement.style.overflow = '';
        var finish = function () {
          if (drawer.classList.contains('kpay-drawer--open')) return;
          drawer.hidden = true;
        };
        drawer.addEventListener('transitionend', finish, { once: true });
        setTimeout(finish, 400);
        inertList.forEach(function (el) { el.removeAttribute('inert'); });
        inertList = [];
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      // Trigger: into the Klarna box (fallback: right after the product form). Only visible candidates:
      // an A/B test can render a second, hidden product section on the page.
      function firstVisible(sel) {
        return Array.prototype.filter.call(document.querySelectorAll(sel), function (el) { return el.getClientRects().length > 0; })[0];
      }
      var host = firstVisible('.product-information .shopify-app-block:has(> klarna-placement)')
        || firstVisible('.product-information product-form-component');
      if (host && !host.querySelector('.kpay__trigger')) {
        var btn = template.content.firstElementChild.cloneNode(true);
        btn.addEventListener('click', open);
        host.appendChild(btn);
      }

      drawer.querySelectorAll('[data-kpay-close]').forEach(function (el) { el.addEventListener('click', close); });
      // A click on empty white space inside the panel (not on content) closes too.
      var scroll = drawer.querySelector('.kpay-drawer__scroll');
      panel.addEventListener('click', function (e) {
        if (e.target === panel || e.target === scroll) close();
      });

      root.kpayOpen = open;
      root.kpayClose = close;
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current && current.kpayClose) current.kpayClose();
  });

  // ---- Klarna text overrides (section setting "Klarna-Text je Land/Sprache ersetzen") ----
  // Klarna renders its on-site message inside an open shadow root; we swap the message text for the
  // configured locale. Re-applied whenever Klarna re-renders (amount change) or the theme replaces the
  // placement (variant change re-renders the product section).
  function klarnaOverrides() {
    var root = document.querySelector('[data-kpay-klarna-overrides]');
    if (!root) return null;
    try { return JSON.parse(root.getAttribute('data-kpay-klarna-overrides')); } catch (e) { return null; }
  }
  function overrideFor(map, locale) {
    if (!map || !locale) return null;
    var parts = locale.split('-');
    return map[locale] || (parts[1] && map[parts[1]]) || map[parts[0]] || null;
  }
  function applyKlarnaText(placement) {
    var map = klarnaOverrides();
    var text = overrideFor(map, placement.getAttribute('data-locale'));
    var sr = placement.shadowRoot;
    if (!text || !sr) return;
    var msg = sr.querySelector('[part~="osm-message"]');
    if (!msg) return;
    // Klarna renders "<text><logo span><cta button>" inside the message element. Keep logo and CTA,
    // replace only the text nodes. "{logo}" in the override places the Klarna logo mid-sentence
    // ("Bezahle mit {logo} – mit 0 % Zinsen"); without it the logo stays after the text.
    var parts = text.split('{logo}');
    var before = parts[0].replace(/\s+$/, '') + (parts.length > 1 ? ' ' : '');
    var after = parts.length > 1 ? ' ' + parts.slice(1).join('').replace(/^\s+/, '') : '';
    var textNodes = Array.prototype.filter.call(msg.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
    if (!textNodes.length) return;
    var logo = msg.querySelector('[part~="osm-logo"]');
    var tail = logo && logo.nextSibling && logo.nextSibling.kpayTail ? logo.nextSibling : null;
    if (textNodes[0].textContent === before && (!after || (tail && tail.textContent === after))) return;
    textNodes[0].textContent = before;
    for (var i = 1; i < textNodes.length; i++) if (textNodes[i] !== tail) textNodes[i].textContent = '';
    if (after && logo) {
      if (!tail) {
        tail = document.createTextNode(after);
        tail.kpayTail = true;
        logo.parentNode.insertBefore(tail, logo.nextSibling);
      } else {
        tail.textContent = after;
      }
    } else if (tail) {
      tail.textContent = '';
    }
  }
  function watchPlacement(placement) {
    if (placement.dataset.kpayWatched) return;
    placement.dataset.kpayWatched = '1';
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (placement.shadowRoot) {
        clearInterval(timer);
        applyKlarnaText(placement);
        new MutationObserver(function () { applyKlarnaText(placement); })
          .observe(placement.shadowRoot, { childList: true, subtree: true, characterData: true });
      } else if (tries > 100 || !placement.isConnected) {
        clearInterval(timer);
      }
    }, 100);
  }
  function watchKlarna() {
    if (!klarnaOverrides()) return;
    document.querySelectorAll('klarna-placement').forEach(watchPlacement);
    new MutationObserver(function () {
      document.querySelectorAll('klarna-placement:not([data-kpay-watched])').forEach(watchPlacement);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchKlarna); else watchKlarna();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-kpay]') : null;
    if (root && root.kpayOpen) root.kpayOpen();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-kpay]') : null;
    if (root && root.kpayClose) root.kpayClose();
  });
})();
/* CUSTOM KIYO END */
